import Box from "@mui/material/Box";

import Typography from "@mui/material/Typography";

import Grid from "@mui/material/Grid";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Role from "../../../../utils/interfaces/IRole";
import "../../../../App.scss";
import PopperComponent from "../popper";
import { isMobile } from "../../../../utils/screenValidations/screen";

type RoleInfoSkill = {
    selectedRole: Role | null;
};

const RoleInfoSkills = ({ selectedRole }: RoleInfoSkill) => {
    return (
        <Box className="boxDescription">
            <List>
                <ListItem disablePadding>
                    <Grid container direction="column">
                        <Grid item>
                            <Box display={"flex"} flexDirection={"row"} alignItems={"center"}>
                                <Typography fontFamily="IliaOpenSansBold" color="#4AC8F5" fontWeight="700" fontSize="16px" lineHeight="21.79px">
                                    Business Skills{" "}
                                </Typography>
                                <PopperComponent isDetails={isMobile()} text="Habilidades relacionadas ao entendimento e visão estratégica do setor de atuação." />
                            </Box>
                        </Grid>
                        <Grid item sx={{ ul: { listStyleType: "disc", marginLeft: 4 } }}>
                            <ul>
                                <Typography fontFamily="IliaOpenSansSemibold" color="#F7F7FF" fontSize="16px" fontWeight="600" lineHeight="21.79px">
                                    {selectedRole?.skills.map(
                                        (skill) => skill.classe === "Business Skill" && <li key={skill.skill_id}>{skill.skill}</li>
                                    )}
                                </Typography>
                            </ul>
                        </Grid>
                    </Grid>
                </ListItem>
                <ListItem disablePadding sx={{ marginTop: 4 }}>
                    <Grid container direction="column">
                        <Grid item>
                            <Box display={"flex"} flexDirection={"row"} alignItems={"center"}>
                                <Typography fontFamily="IliaOpenSansBold" color="#4AC8F5" fontWeight="700" fontSize="16px" lineHeight="21.79px">
                                    Hard Skills{" "}
                                </Typography>
                                <PopperComponent isDetails={isMobile()} text="Habilidades técnicas e domínio de ferramentas essenciais para desempenhar as funções do cargo." />
                            </Box>
                        </Grid>
                        <Grid item sx={{ ul: { listStyleType: "disc", marginLeft: 4 } }}>
                            <ul>
                                <Typography fontFamily="IliaOpenSansSemibold" color="#F7F7FF" fontSize="16px" fontWeight="600" lineHeight="21.79px">
                                    {selectedRole?.skills.map(
                                        (skill) => skill.classe === "Hard Skill" && <li key={skill.skill_id}>{skill.skill}</li>
                                    )}
                                </Typography>
                            </ul>
                        </Grid>
                    </Grid>
                </ListItem>
                <ListItem disablePadding sx={{ marginTop: 4 }}>
                    <Grid container direction="column">
                        <Grid item>
                            <Box display={"flex"} flexDirection={"row"} alignItems={"center"}>
                                <Typography fontFamily="IliaOpenSansBold" color="#4AC8F5" fontWeight="700" fontSize="16px" lineHeight="21.79px">
                                    Soft Skills{" "}
                                </Typography>
                                <PopperComponent isDetails={isMobile()} text="Habilidades interpessoais como comunicação e trabalho em equipe, cruciais para interações eficazes." />
                            </Box>
                        </Grid>
                        <Grid item sx={{ ul: { listStyleType: "disc", marginLeft: 4 } }}>
                            <ul>
                                <Typography fontFamily="IliaOpenSansSemibold" color="#F7F7FF" fontSize="16px" fontWeight="600" lineHeight="21.79px">
                                    {selectedRole?.skills.map(
                                        (skill) => skill.classe === "Soft Skill" && <li key={skill.skill_id}>{skill.skill}</li>
                                    )}
                                </Typography>
                            </ul>
                        </Grid>
                    </Grid>
                </ListItem>
            </List>
        </Box>
    );
};

export default RoleInfoSkills;
